<script>
import { mapGetters } from 'vuex';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
  },
  emits: ['replace'],
  computed: {
    ...mapGetters('cannedResponse', {
      cannedMessages: 'getCannedResponses',
    }),
    items() {
      // Filter out multimedia and interactive canned responses from the shortcut selector
      // since they can't be meaningfully inserted as text
      return (this.cannedMessages || [])
        .filter(cannedMessage => cannedMessage.content_type === 'text')
        .map(cannedMessage => ({
          label: cannedMessage.short_code,
          key: cannedMessage.short_code,
          description: cannedMessage.content,
        }));
    },
  },
  watch: {
    searchKey() {
      this.fetchCannedResponses();
    },
  },
  mounted() {
    this.fetchCannedResponses();
  },
  methods: {
    fetchCannedResponses() {
      this.$store.dispatch('cannedResponse/getCannedResponse', {
        searchKey: this.searchKey,
      });
    },
    handleMentionClick(item = {}) {
      this.$emit('replace', item.description);
    },
  },
};
</script>

<template>
  <div>
    <MentionBox
      v-if="items.length"
      :items="items"
      @mention-select="handleMentionClick"
    />
  </div>
</template>
